import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import ScenarioSelectionAssumptions from './ScenarioSelectionAssumptions/ScenarioSelectionAssumptions';

const ScenarioSelectionAssumptionsPicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.assumptions.name]: <ScenarioSelectionAssumptions relationship={resource.relationship(fr.relationships.assumptions.name)} />,
  }, null);
};

ScenarioSelectionAssumptionsPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
ScenarioSelectionAssumptionsPicker.defaultProps = {
};

export default ScenarioSelectionAssumptionsPicker;
